import { render } from "./LanguageSwitcher.vue?vue&type=template&id=b3aa60be"
import script from "./LanguageSwitcher.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&charset=utf-8&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=b3aa60be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__